var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicAccessWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}.c{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#71778a",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.22 21.648)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.334,12.224A7.342,7.342,0,0,1,0,4.89V.734A.734.734,0,0,1,.734,0h13.2a.734.734,0,0,1,.734.733V4.89A7.343,7.343,0,0,1,7.334,12.224Zm0-8.556a1.222,1.222,0,0,0-.675,2.241L6.035,7.871H8.7L7.987,5.923a1.222,1.222,0,0,0-.653-2.255Z",
    transform: "translate(0 8.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6287.227,6637.337v-3.873s.47-5.086,5.548-5.036c4.777.037,5.068,4.072,5.068,4.072",
    transform: "translate(-6285.414 -6628.427)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicAccessWhite);
export default __webpack_public_path__ + "static/media/public_access_white.85f1cc0ec9bfa5da85bbd263a424f869.svg";
export { ForwardRef as ReactComponent };